export default __webpack_public_path__ + "static/media/gallery02.eaa03c2a.png";